import styled from "react-emotion";
import { H1 } from "../../elements/Heading";

const Container = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 400px;
  width: 100%;
  padding-bottom: 15px;
`;

const Header = styled(H1)`
  margin-top: 20px;
  margin-bottom: 30px;
`;

const FormContainer = styled("div")`
  margin-bottom: 45px;
`;

const Switch = styled("span")`
  cursor: pointer;
  margin-top: 5px;
  margin-bottom: 5px;
  text-decoration: underline;

  :hover {
    color: lightblue;
  }
`;

export { Header, Switch, FormContainer, Container };



// WEBPACK FOOTER //
// ./src/routes/Login/Styles.tsx